import { CONSOLE_REQUEST_ENABLE, CONSOLE_RESPONSE_ENABLE } from '../index'
import VM from '../../main'
import { fixReqPayloadAdjustDataPermission } from './fixReqPayloadAdjustDataPermission'
import { getEnvToHeader, handleEnvChange } from './abEnv'

export function requestSuccessFuncErp(req) {
  CONSOLE_REQUEST_ENABLE && console.info('requestSuccess', '\n', req)
  // 自定义请求拦截逻辑，可以处理权限，请求发送监控等
  const tokenObj = VM.$utils.getToken()
  const sid = VM.$ls.get('sid')
  const account = VM.$ls.get('account')
  req.headers.s = 1
  req.headers.r = window.location.href
  if (tokenObj?.token) {
    req.headers.token = tokenObj.token
    if (tokenObj.xFrom) {
      req.headers['X-from'] = 1
    }
  }
  if (sid) {
    req.headers.userInfo = `sid=${encodeURIComponent(sid)},account=${encodeURIComponent(account)}`
  }

  // 修正 reqData, 配合数据权限
  const curReq = fixReqPayloadAdjustDataPermission(req)
  return curReq
  // return req
}

export function requestFailFuncErp(err) {
  // 自定义发送请求失败逻辑，断网，请求发送监控等
  return Promise.reject(err)
}

export function responseSuccessFuncErp(res) {
  const onlySuccessUrls = [ // 不处理异常的接口们
    '/api/tenant/logout',
    '/api/trace',
    '/api/dump',
  ]
  if (onlySuccessUrls.find(item => res.config.url === item)) {
    return { code: 200 }
  }

  // 自定义响应成功逻辑，全局拦截接口，根据不同业务做不同处理，响应成功监控等
  if (res.config.responseType === 'blob' && res.status === 204) {
    return VM.$message.error('该时段尚无数据')
  }

  // 如果返回的额是blob, 且设置了返回所有，那就返回所有数据
  // 场景，需要从header中获取文件名称
  if (res.config.responseType === 'blob' && res.config.options.customGetFullRes === true) {
    return res
  }

  if (res.config.responseType === 'blob') {
    return res.data
  }

  if (res.config?.options?.ignoreCodeHandler === true) {
    console.log('ajax/interceptor/responseSuccessFunc ignoreCodeHandler', res?.config?.url)
    return res.data
  }

  const { code, msg, msgType } = res.data
  const requestUrl = res.config.url // 获取请求的URL
  const envValue = res.data?.data?.env // 获取响应头中的 env 字段的值

  switch (code) {
    case 200:
      if (requestUrl.includes('home/user/login') && envValue) {
        console.log('api/login 接口的 env 值为:', envValue)
        VM.$ls.set('env', envValue)
      }
      break
    case 40005:
      // token 失效
      if (msgType && ['success', 'warning', 'info', 'error'].includes(msgType)) {
        VM.$message[msgType](msg)
      }
      VM.$store.dispatch('user/logout', { type: 'auto' }).then((xFrom) => {
        if (xFrom === 1) {
          // 北京跳过来的
          location.href = `${VM.$utils.getErpDomain()}/login?redirect=${encodeURIComponent(location.href)}&type=bi`
        } else {
          // 深圳独立部署
          const isLoginPage = VM?.$route?.name === 'login'

          if (!isLoginPage) {
            // 如果不在登录页，才需要跳转
            VM.$router.push({
              name: 'login',
              query: { redirect: VM.$router.currentRoute.fullPath }
            })
          }
        }
      })
      break
    case 401:
      VM.$router.push({ name: 'noActive' })
      break
    // case 40022:
    //   VM.$router.push({ name: 'noActive' })
    //   break
    case 1001:
      VM.$router.push({ name: 'developing' })
      break
    default:
      // 新逻辑，只有有msgType，后端指定要弹出消息
      if (!msg) {
        break
      }

      if (msgType && ['success', 'warning', 'info', 'error'].includes(msgType)) {
        VM.$message[msgType](msg)
      } else {
        VM.$message.error(msg)
      }

      break
  }
  return res.data
}

export function responseFailFuncErp(err) {
  // 响应失败，可根据 err.message 和 err.response 来做监控处理
  const { message, response } = err
  // eslint-disable-next-line
  CONSOLE_RESPONSE_ENABLE && console.info('responseFail', '\n', `message: ${message}`, '\n', response)
  if (response && response.config) {
    const { config: { options: { isOpenErrorIntercept } } } = response
    if (!isOpenErrorIntercept) {
      // 自定义全局错误拦截处理
    }
  }
  VM.$message.error('网络或服务器异常,请稍后重试!')
  return Promise.reject(err)
}
